import React from 'react'

export default function FaceFeature({ scaleX, outline }) {
  return (
    <g transform={`scale(${scaleX},1)`} style={{ opacity: 0.2 }}>
      <path
        d="M0 0.942017C1.55 1.60202 3.05001 2.142 4.57001 2.552C6.09001 2.952 7.61003 3.17202 9.12003 3.19202C10.63 3.21202 12.15 3.06195 13.64 2.62195C14.4 2.46195 15.12 2.15196 15.88 1.88196C16.64 1.61196 17.34 1.21201 18.16 0.932007C17.62 1.56201 17.04 2.20193 16.37 2.73193C15.68 3.22193 14.99 3.76203 14.18 4.08203C13.41 4.51203 12.55 4.70202 11.71 4.94202C10.85 5.08202 9.97 5.23201 9.09 5.18201C7.33 5.16201 5.59001 4.73195 4.04001 4.00195C2.48001 3.28195 1.06 2.27202 0 0.942017Z"
        fill={outline}
      />
    </g>
  )
}
